import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import PropTypes from 'prop-types'
import { NextUpBackground, NextUpContent, NextUpMain } from './index.style'
import Container from '../Container'
import Spacer from '../Spacer'
import Button from '../Button'
import PageTransitionLink from '../PageTransitionLink'
import { Heading3, Label } from '../TextStyles'
import { GatsbyImage } from 'gatsby-plugin-image'
import { colors } from '../../styles/vars/colors.style'
import ScrollSection from '../ScrollSection'
import AnimateSlideIn from '../animation/AnimateSlideIn'
import AnimateScaleIn from '../animation/AnimateScaleIn'
import AnimateSplitText from '../animation/AnimateSplitText'

const NextUp = ({ id, backgroundImage, number, labelColor, title, to }) => {
  const {
    contentfulGlobalSettings: { nextUp, expedition },
  } = useStaticQuery(graphql`
    query {
      contentfulGlobalSettings {
        nextUp
        expedition
      }
    }
  `)

  return (
    <ScrollSection>
      <NextUpMain>
        <NextUpBackground>
          <AnimateScaleIn id={`${id}-nextUp-image`}>
            <GatsbyImage image={backgroundImage} alt="" />
          </AnimateScaleIn>
        </NextUpBackground>

        <Container>
          <NextUpContent>
            <Spacer size={[119, 238]} />

            <AnimateSlideIn id={`${id}-nextUp-label`}>
              <Label bgColor={labelColor}>{nextUp}</Label>
            </AnimateSlideIn>

            <Spacer size={[16, 32]} />

            <Heading3>
              <AnimateSplitText id={`${id}-nextUp-title`}>
                <em>
                  {`${expedition} ${number}`}
                  <br />
                </em>{' '}
                <span dangerouslySetInnerHTML={{ __html: title }}></span>
              </AnimateSplitText>
            </Heading3>

            <Spacer size={[37, 74]} />

            <AnimateSlideIn id={`${id}-nextUp-button`}>
              <PageTransitionLink to={to} mask={false}>
                <Button inline variant="outline" color={colors.light}>
                  Explore
                </Button>
              </PageTransitionLink>
            </AnimateSlideIn>

            <Spacer size={[119, 238]} />
          </NextUpContent>
        </Container>
      </NextUpMain>
    </ScrollSection>
  )
}

NextUp.propTypes = {
  id: PropTypes.string,
  background: PropTypes.object,
  number: PropTypes.string,
  labelColor: PropTypes.string,
  title: PropTypes.string,
  to: PropTypes.string,
}

export default NextUp
